import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UserVideos from "./UserVideos";
import { Link } from "react-router-dom";

const PatientCelebrity = () => {
  return (
    <>
      {/* <div
        className="container my-3 my-sm-5"
        id="celebraties_services_home"
        data-aos="fade-up"
      >
        <div className="need-heading">
          <h1 className="text-center text-til my-3"> VIDEO TESTIMONIALS</h1>
        </div>
        <div
          className="row align-items-center justify-content-center"
          data-aos="fade-up"
        >
          <div className="col-6">1</div>
          <div className="col-6">1</div>
        </div>
      </div> */}
      <div className="container mt-lg-5 mb-lg-5">
        <div className="need-heading">
          <h2 className="text-center text-til my-3"> VIDEO TESTIMONIALS</h2>
        </div>
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 text-center ">
            <div className="need-heading">
              <h2 className="text-center text-til my-3">
                PATIENT TESTIMONIALS
              </h2>
            </div>
            <iframe
              width="80%"
              height="250px"
              // src="https://youtu.be/MqO6ewP-4uk"
              srcdoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/MqO6ewP-4uk/?autoplay=1><img src=https://img.youtube.com/vi/MqO6ewP-4uk/hqdefault.jpg alt='AltTagContent'><span>▶</span></a>"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <div className="m-4">
              <Link
                className="trending-button"
                to="/patient-testimonials"
                target="_blank"
              >
                View More
              </Link>
            </div>
          </div>
          <div className="col-lg-6 text-center">
            <div className="need-heading">
              <h2 className="text-center" id="gradient-text">
                CELEBRITY TESTIMONIALS
              </h2>
            </div>
            <iframe
              width="80%"
              height="250px"
              // src="https://www.youtube.com/embed/Lit5x-1EzJU"
              srcdoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/Lit5x-1EzJU/?autoplay=1><img src=https://img.youtube.com/vi/Lit5x-1EzJU/hqdefault.jpg alt='AltTagContent'><span>▶</span></a>"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <div className="m-4">
              <Link
                className="trending-button"
                to="/celebrity-testimonials"
                target="_blank"
              >
                View More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientCelebrity;
